import Theme12 from "./theme12"

export default function Index(props) {
    const theme = props?.pageInfo?.site?.site_theme
    switch (theme) {
      case 'theme12':
          return <Theme12 {...props} />
      default:
        return <Theme12 {...props} />
    }
  }